<app-sidebar (toggleChange)="collapsedSidebar = $event" />
<app-topbar />
<div
    class="main-content-area"
    #mainContent
    [class.panel-open]="rightPanelVisible"
    [class.panel-expanded]="rightPanelExpanded"
    [class.panel-expanded-collapsed-sidebar]="rightPanelExpanded && collapsedSidebar"
    [class.panel-collapsed]="rightPanelCollapsed"
>
    <ng-content />
</div>
<app-right-panel
    [isVisible]="rightPanelVisible"
    [isExpanded]="rightPanelExpanded"
    [isCollapsed]="rightPanelCollapsed"
    [content]="rightPanelContent"
    (visibilityChange)="onRightPanelVisibilityChange($event)"
    (expandedChange)="onRightPanelExpandedChange($event)"
    (collapsedChange)="onRightPanelCollapsedChange($event)"
/>
<a #downloadLink id="downloadLink" class="hiddenDownloadLink">hidden download link</a>
